// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"main-content_mainContent__fcX1g"};